/**
 * IssueChip — ein Issue als Severity-farbiger Chip mit konkretem Text.
 * Zeigt actual/expected ("title 145 → 25") oder Fallback message.
 */
import type { ProductIssue, IssueSeverity } from '@/lib/api/channel-readiness'
import { cn } from '@/lib/utils'

const SEVERITY_CLASS: Record<IssueSeverity, string> = {
  error: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-900',
  warning:
    'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/20 dark:text-amber-400 dark:border-amber-900',
  info: 'bg-neutral-100 text-neutral-700 border-neutral-200 dark:bg-neutral-800/40 dark:text-neutral-300 dark:border-neutral-700',
}

interface IssueChipProps {
  issue: ProductIssue
}

export function IssueChip({ issue }: IssueChipProps) {
  const severity: IssueSeverity = issue.severity ?? 'info'
  const detail =
    issue.actual != null && issue.expected != null
      ? `${issue.actual} → ${issue.expected}`
      : issue.message

  return (
    <span
      aria-label={`${issue.field}: ${detail}`}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs',
        SEVERITY_CLASS[severity]
      )}
    >
      <span className="font-mono font-medium">{issue.field}</span>
      <span className="opacity-80">{detail}</span>
    </span>
  )
}
